<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">

        
        <h4>List of Roles</h4>
        
        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <Button
            label="New Role"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            style="margin-right: 1em"
            @click="openNew"
          />
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="globalSearch"
                placeholder="Global Search"
                style="margin-right: 0.5em"
                @input="updateSearch"
              />
            </span>
          </div>
        </div>
  
      </div>
    </div>

    <div style="overflow-x: scroll;">
      <RolesTable
        :key="rolesTableKey1"
        :roles="roles"
        :loading="loading"
        @edit-role="editRoles"
      />
    </div>
    
    <RolesForm
      :rolesForm="rolesFormDialog"
      :reloadForm="reloadRolesForm"
      :disabledArr="disabledArr"
      :roleToEdit="role"
      @close="rolesFormDialog = false"
      @saved="saved"
      @updated="updated"
    />
  </div>
</template>

<script>
import RoleService from "@/service/RoleService";

import RolesTable from '../universalComponents/roles/RolesTable'
import RolesForm from '../universalComponents/roles/RolesForm'

export default {
  components: {
    RolesTable,
    RolesForm
  },
  data: () => ({
    roleService: new RoleService(),
    globalSearch: '',
    roles: [],
    rolesTableKey: 0,
    requesting: false,
    rolesFormDialog: false,
    reloadRolesForm: 0,
    disabledArr: [],
    role: {}
  }),
  computed: {
    rolesTableKey1: {
      set(val) {
        this.rolesTableKey++
      },
      get() {
        return 'RolesTable' + this.rolesTableKey.toString()
      }
    },
    loading() {
      if (this.roles && this.roles[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    }
  },
  created() {
    this.getAllRolesByHard()
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
  },
  watch: {
    globalSearch(val) {
      this.rolesTableKey1++
    },
    roles(val) {
      if (val && Array.isArray(val)) {
        this.rolesTableKey1++
      }
    }
  },
  methods: {
    updated(role) {
      
      this.rolesFormDialog = false

      // if (role.id) {
      //   let index = this.roles.findIndex(a => a.id === role.id)
      //   
      //   this.roles[index] = role
      // } else {
        this.getAllRolesByHard()
      // }

      this.$toast.add({
        severity: "success",
        summary: "Success",
        detail: "role updated successfully",
        life: 5000,
      });
    },
    editRoles(role) {
      
      this.role = role
      this.rolesFormDialog = true
      this.reloadRolesForm++
    },
    saved(data) {
      // 
      this.getAllRolesByHard()
      this.rolesFormDialog = false
      
      this.$toast.add({
        severity: "success",
        summary: "Success",
        detail: "role created successfully",
        life: 5000,
      });
    },
    openNew() {
      this.role = {}
      this.disabledArr = []
      this.rolesFormDialog = true
      this.reloadRolesForm++
    },
    getAllRolesByHard() {
      this.roles = []
      this.requesting = true

      this.roleService
        .getAllRolesByHard()
        .then(data => {
          this.requesting = false
          this.roles = data
        })
        .catch((e) => {
          
            
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting roles",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "roles"'
          })
        });
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    }
  }
}
</script>

<style>

</style>